import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Paper, ThemeProvider } from '@mui/material'

import { internalLightTheme } from '~createInternalTheme'
import PageNotFoundScreen from '~pages/PageNotFoundScreen'

import AIInteractionLogContent from '../../components/AIInteractionLogContent'

import './AIInteractionLogViewerPage.scss'

const AIInteractionLogViewerPageContent: React.FC = () => {
  const { aiInteractionId } = useParams<{ aiInteractionId: string }>()
  const [showPageNotFound, setShowPageNotFound] = useState(false)

  const handleError = (): void => {
    setShowPageNotFound(true)
  }

  if (showPageNotFound) {
    return <PageNotFoundScreen permissionsError={true} />
  }

  return (
    <div className='interaction-log-viewer'>
      <Paper elevation={0}>
        <AIInteractionLogContent
          aiInteractionId={aiInteractionId || ''}
          showOrgInfo={true}
          onError={handleError}
          debugToggleMode='floating'
        />
      </Paper>
    </div>
  )
}

const AIInteractionLogViewerPage: React.FC = () => {
  return (
    <ThemeProvider theme={internalLightTheme}>
      <AIInteractionLogViewerPageContent />
    </ThemeProvider>
  )
}

export default AIInteractionLogViewerPage
